<template>
  <div class="container-fluid mt-4">
    <div class="row mb-5">
      <div class="col-lg-3">
        <brand-side-menu />
      </div>
      <div class="col-lg-9 mt-lg-0 mt-4">
        <brand-side-menu-item />
      </div>
    </div>
  </div>
</template>

<script>

  import BrandSideMenu from "./components/BrandSideMenu.vue";
  import BrandSideMenuItem from "./components/BrandSideMenuItem.vue";

  export default {
    name: "BrandDetails",
    components: {
      BrandSideMenu,
      BrandSideMenuItem,
    },
  };

</script>
